export const SET_WORK = "setWork";

export const setWork = (payload: any) => {
  return {
    type: SET_WORK,
    payload,
  };
};
